/** @jsx jsx */
import React, { type ReactNode } from 'react';
import { keyframes, css, jsx } from '@compiled/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { keyframes as styledKeyframes } from 'styled-components';
import { token } from '@atlaskit/tokens';
import { zIndex } from '../../../common/constants/styles/index.tsx';

// TODO: delete this when cleaning up jira_inline_edit_boards_m1_experiment
type RipplePropsOld = {
	children: ReactNode;
	onAnimationEnd: () => void;
};

export type RippleProps = {
	children: ReactNode;
	onAnimationEnd: () => void;
	shouldAnimate: boolean;
};

// TODO: delete this when cleaning up jira_inline_edit_boards_m1_experiment
export const RippleOld = ({ onAnimationEnd, children }: RipplePropsOld) => (
	<RippleContainer onAnimationEnd={onAnimationEnd}>{children}</RippleContainer>
);

export const Ripple = ({ onAnimationEnd, children, shouldAnimate }: RippleProps) => {
	return (
		<div
			data-testid="platform-board-kit.ui.card.ripple.div"
			onAnimationEnd={onAnimationEnd}
			css={[rippleContainer, shouldAnimate && rippleAnimation]}
		>
			{children}
		</div>
	);
};

const RippleAnimation = keyframes({
	from: {
		boxShadow: '0 0 0 0 #14892c',
	},
	to: {
		boxShadow: '0 0 0 15px rgba(0, 0, 0, 0)',
	},
});

const rippleContainer = css({
	position: 'relative',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	zIndex: 'auto',
});

const rippleAnimation = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	zIndex: zIndex.cardDoneRipple,
	animationName: RippleAnimation,
	animationDuration: '1.45s',
	animationIterationCount: 1,
	animationTimingFunction: 'cubic-bezier(0.14, 1.17, 0.95, 0.99)',
});

// TODO: delete this when cleaning up jira_inline_edit_boards_m1_experiment
const RippleAnimationOld = styledKeyframes({
	from: {
		boxShadow: '0 0 0 0 #14892c',
	},
	to: {
		boxShadow: '0 0 0 15px rgba(0, 0, 0, 0)',
	},
});

// TODO: delete this when cleaning up jira_inline_edit_boards_m1_experiment
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RippleContainer = styled.div({
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: zIndex.cardDoneRipple ? zIndex.cardDoneRipple : 'auto',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	animationName: RippleAnimationOld,
	animationDuration: '1.45s',
	animationIterationCount: 1,
	animationTimingFunction: 'cubic-bezier(0.14, 1.17, 0.95, 0.99)',
});
